import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, withStyles,
} from '@material-ui/core';
import LocalizedString from '../../localization';

const styles = () => ({
  dialogHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  container: {
    padding: '0px 16px 16px',
    width: '100%',
  },
  text: {
    padding: 8,
  },
});

const InfoDialog = ({
  classes, visibility, onClosePressed, message,
}) => (
  <Dialog open={visibility}>
    <DialogTitle>
      <div className={classes.dialogHeader}>
        <Typography color="primary" variant="h6">
          {LocalizedString.common.alertTitleInfo}
        </Typography>
      </div>
    </DialogTitle>
    <DialogContent className={classes.container}>
      <Typography className={classes.text}>
        {message}
      </Typography>
      <DialogActions>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={onClosePressed}
        >
          {LocalizedString.common.buttonCaptionOK}
        </Button>
      </DialogActions>
    </DialogContent>
  </Dialog>
);

export default withStyles(styles)(InfoDialog);

InfoDialog.propTypes = {
  classes: PropTypes.shape(PropTypes.any).isRequired,
  visibility: PropTypes.bool.isRequired,
  onClosePressed: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};
